import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AttendanceQRModal from './AttendanceQRModal';

function SideBar() {
  const [isCoursesOpen, setIsCoursesOpen] = useState(false);
  const [isBatchOpen, setIsBatchOpen] = useState(false);
  const [isStudentsOpen, setIsStudentsOpen] = useState(false);
  const [isBlogsOpen, setIsBlogsOpen] = useState(false);
  const [isContentsOpen, setIsContentsOpen] = useState(false);
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [isMockExamOpen, setIsMockExamOpen] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const navigate = useNavigate();

  const toggleCoursesDropdown = () => setIsCoursesOpen(!isCoursesOpen);
  const toggleStudentsDropdown = () => setIsStudentsOpen(!isStudentsOpen);
  const toggleBlogsDropdown = () => setIsBlogsOpen(!isBlogsOpen);
  const toggleContentsDropdown = () => setIsContentsOpen(!isContentsOpen);
  const toggleAttendanceDropdown = () => setIsAttendanceOpen(!isAttendanceOpen);
  const toggleMockExamDropdown = () => setIsMockExamOpen(!isMockExamOpen);

  const handleLogout = () => {
    sessionStorage.removeItem('studentSession');
    navigate('/login');
  };

  useEffect(() => {
    console.log('SideBar mounted. Initial dropdown states:', {
      isCoursesOpen,
      isStudentsOpen,
      isBlogsOpen,
      isContentsOpen
    });

    // Debug submenu visibility and class application
    const submenus = document.querySelectorAll('.sidebar-submenu');
    submenus.forEach((submenu, index) => {
      const isOpen = submenu.classList.contains('open');
      console.log(`Submenu ${index + 1} display:`, window.getComputedStyle(submenu).display, `open class: ${isOpen}`);
    });

    // Debug icon rendering
    const icons = document.querySelectorAll('.dropdown-icon');
    icons.forEach((icon, index) => {
      console.log(`Icon ${index + 1} class:`, icon.className);
    });

    // Ensure dropdown buttons are clickable
    const dropdownButtons = document.querySelectorAll('.sidebar-menu__link.has-dropdown');
    dropdownButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log(`Dropdown button clicked: ${btn.textContent}`);
      });
    });

    // Cleanup event listeners
    return () => {
      dropdownButtons.forEach((btn) => {
        btn.removeEventListener('click', () => {});
      });
    };
  }, [isCoursesOpen, isStudentsOpen, isBlogsOpen, isContentsOpen]);

  return (
    <>
      {/*==================== Sidebar Overlay End ====================*/}
      <div className="side-overlay" />
      {/*==================== Sidebar Overlay End ====================*/}
      {/* ============================ Sidebar Start ============================ */}
      <aside className="sidebar">
        {/* sidebar close btn */}
        <button
          type="button"
          className="sidebar-close-btn text-gray-500 hover-text-white hover-bg-main-600 text-md w-24 h-24 border border-gray-100 hover-border-main-600 d-xl-none d-flex flex-center rounded-circle position-absolute"
        >
          <i className="ph ph-x" />
        </button>
        {/* sidebar close btn */}
        <Link
          to="/dashboard"
          className="sidebar__logo text-center p-20 position-sticky inset-block-start-0 bg-white w-100 z-1 pb-10"
        >
          <img src="/assets/images/logo/logo.jpg" alt="Logo" />
        </Link>
        <div className="sidebar-menu-wrapper overflow-y-auto scroll-sm">
          <div className="p-20 pt-10">
            <ul className="sidebar-menu">
              <li className="sidebar-menu__item">
                <Link to="/dashboard" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-squares-four" />
                  </span>
                  <span className="text">Dashboard</span>
                </Link>
              </li>
                 <li className="sidebar-menu__item">
                <Link to="/courses" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-graduation-cap" />
                  </span>
                  <span className="text">Course</span>
                </Link>
              </li>
{/* /student-resources */}
                    <li className="sidebar-menu__item">
                <Link to="/student-resources" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-books" />
                  </span>
                  <span className="text">Resources</span>
                </Link>
              </li>
              <li className="sidebar-menu__item">
                <Link to="/student-case-studies" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-briefcase" />
                  </span>
                  <span className="text">Case Studies</span>
                </Link>
              </li>

                  <li className={`sidebar-menu__item ${isAttendanceOpen ? 'active' : ''}`}>
                <button
                  type="button"
                  className="sidebar-menu__link"
                  onClick={toggleAttendanceDropdown}
                  aria-expanded={isAttendanceOpen}
                >
                  <span className="icon">
                    <i className="ph ph-calendar" />
                  </span>
                  <span className="text">Attendance</span>
                  <i className={`ph ph-caret-down dropdown-icon ${isAttendanceOpen ? 'rotate-180' : ''}`} />
                </button>
                <ul
                  className={`sidebar-submenu ${isAttendanceOpen ? 'open' : ''}`}
                  style={{ display: isAttendanceOpen ? 'block' : 'none' }}
                >
                  <li className="sidebar-submenu__item">
                    <button
                      type="button"
                      className="sidebar-submenu__link"
                      style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
                      onClick={() => setShowQrModal(true)}
                    >
                      Attendance QR
                    </button>
                  </li>
                  <li className="sidebar-submenu__item">
                    <Link to="/student-my-attendance" className="sidebar-submenu__link">
                      My Attendance
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={`sidebar-menu__item ${isMockExamOpen ? 'active' : ''}`}>
                <button
                  type="button"
                  className="sidebar-menu__link"
                  onClick={toggleMockExamDropdown}
                  aria-expanded={isMockExamOpen}
                >
                  <span className="icon">
                    <i className="ph ph-clipboard-text" />
                  </span>
                  <span className="text">Mock Exams</span>
                  <i className={`ph ph-caret-down dropdown-icon ${isMockExamOpen ? 'rotate-180' : ''}`} />
                </button>
                <ul
                  className={`sidebar-submenu ${isMockExamOpen ? 'open' : ''}`}
                  style={{ display: isMockExamOpen ? 'block' : 'none' }}
                >
                  <li className="sidebar-submenu__item">
                    <Link to="/mock-exams" className="sidebar-submenu__link">
                      Available Exams
                    </Link>
                  </li>
                  <li className="sidebar-submenu__item">
                    <Link to="/mock-exam-history" className="sidebar-submenu__link">
                      My Exam History
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="sidebar-menu__item">
                <Link to="/assignments" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-file-text" />
                  </span>
                  <span className="text">Assignments</span>
                </Link>
              </li>

              <li className="sidebar-menu__item">
                <Link to="/fees" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-coins" />
                  </span>
                  <span className="text">Fees Details</span>
                </Link>
              </li>
              <li className="sidebar-menu__item">
                <span className="text-gray-300 text-sm px-20 pt-20 fw-semibold border-top border-gray-100 d-block text-uppercase">
                  Settings
                </span>
              </li>
              <li className="sidebar-menu__item">
                <Link to="/profile" className="sidebar-menu__link">
                  <span className="icon">
                    <i className="ph ph-gear" />
                  </span>
                  <span className="text">Profile Settings</span>
                </Link>
              </li>
              <li className="sidebar-menu__item">
                <button
                  type="button"
                  className="sidebar-menu__link"
                  onClick={handleLogout}
                >
                  <span className="icon">
                    <i className="ph ph-shield-check" />
                  </span>
                  <span className="text">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </aside>
      {/* ============================ Sidebar End  ============================ */}
      {showQrModal && <AttendanceQRModal onClose={() => setShowQrModal(false)} />}
    </>
  );
}

export default SideBar;